/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export interface ActionInfo {
  /** Action error object identifier */
  id?: string;

  /** Action error message */
  message?: string;
}

export interface ActionResult {
  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface Alias {
  /** Unique identifier of the alias entry. */
  id: string;

  /** User-defined alias text that serves as an alternative name or code for the associated product. */
  value: string;

  /** Identifier of the product that this alias is associated with. */
  productId: string;

  /** Date and time when the alias was last modified. */
  dateModified: Date;

  /** Date and time when the alias was originally created. */
  dateCreated: Date;
}

export interface AliasActionResult {
  /** Collection of aliases that were successfully created or updated as part of this action. */
  aliases?: Alias[];

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface AliasAddAction {
  /** Aliases to add */
  aliases: AliasAddItem[];

  /**  */
  appSettings: CatalogAppSettings;
}

export interface AliasAddItem {
  /** Product id */
  productId: string;

  /** Alias value */
  value: string;
}

export interface AliasDeleteAction {
  /** Aliases to delete */
  aliases: AliasDeleteItem[];

  /**  */
  appSettings: CatalogAppSettings;
}

export interface AliasDeleteItem {
  /** Alias id */
  id: string;
}

export interface AliasExportAction {
  /**  */
  appSettings: CatalogAppSettings;
}

export interface AliasImportAction {
  /** File content in Base64 */
  fileContentBase64: string;

  /** File name */
  fileName: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface AliasItem {
  /** Indicates whether the current user has permission to edit this alias. */
  editable: boolean;

  /** Unique identifier of the alias entry. */
  id: string;

  /** User-defined alias text that serves as an alternative name or code for the associated product. */
  value: string;

  /** Identifier of the product that this alias is associated with. */
  productId: string;

  /** Date and time when the alias was last modified. */
  dateModified: Date;

  /** Date and time when the alias was originally created. */
  dateCreated: Date;
}

export interface AliasListQuery {
  /**  */
  search: ListSearchSettings;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface AliasListSearchResult {
  /** Collection of alias items matching the search criteria. */
  items?: AliasItem[];
}

export interface AliasSettings {
  /** List of customers for which alias display and search is enabled. Each customer is identified by system ID, sales unit, and customer ID. */
  customers?: Customer[];
}

export interface AliasSynchronizeAction {
  /**  */
  appSettings: CatalogAppSettings;
}

export interface AppSettings {
  /** ISO country code used to filter products by Country Market Availability.
Only product instances available for the designated country will be returned. */
  countryCode?: string;

  /**  */
  treeType?: TreeTypeEnum;

  /** When set to true, includes internal-only attributes visible to ABB users. Requires application-level authorization. */
  internalUser?: boolean;

  /**  */
  aliases?: AliasSettings;

  /**  */
  filters?: ApplicationFilters;

  /**  */
  appSpecific?: AppSpecificSettings;

  /** AGM (Attribute Group Management) predefined list code. When provided, search results are pre-filtered
to show only attributes and values defined in the specified AGM list. */
  agmListCode?: string;

  /** When set to true, enables filtering of product relationships in product detail views. */
  productRelationshipFiltering?: boolean;

  /**  */
  variant?: VariantSettings;

  /** Application code identifying the front-end application. Products are filtered by their Publishers attribute to match this code. Required. */
  appCode: string;

  /** ISO language code for translations of labels, attribute names, and values. Defaults to "en" (English). */
  langCode?: string;

  /**  */
  client?: ClientInfo;

  /**  */
  sort?: AppSortSettings;
}

export interface AppSortSettings {
  /** Ordered list of attribute sort mappings. Each entry defines sorting behavior for a specific product attribute. */
  map?: MapSettings[];
}

export interface AppSpecificSettings {
  /** Associated Group values. Restricts results to products that belong to the specified customer groups and enables customer-specific product logic. */
  associatedGroups?: string[];

  /** When `true`, removes the leading "ABB" prefix from attribute display names in the response. */
  genericizeAttName?: boolean;

  /** Sales Unit Organization code. Enables Local Order Code search and display for the specified sales unit. */
  salesUnitCode?: string;

  /** Front-end filter values. Products whose "Front End Filter" attribute matches any of the provided values will be excluded from results. */
  frontEndFilter?: string[];

  /** Maximum depth of the classification tree to return. A value of 0 (default) returns all children of the CID node. Used only in the Search method. */
  treeDepth?: number;

  /** When `true`, returns all available replacement products. When `false`, only replacements for obsolete or inactive products are returned. Applicable only in the Search method. */
  allReplacements?: boolean;

  /** Sales unit codes for local products. Includes products marked as "Local Product" = "Yes" that are normally hidden from standard search results. */
  sellingUnitForLocalProducts?: string[];

  /** When `true`, product table data matching is performed per row instead of against the entire data set. */
  tableRowMatching?: boolean;

  /** When `true`, the response includes related products in the product detail output. */
  relatedProducts?: boolean;

  /** Standardization body codes (e.g. "IEC", "UL"). When specified, attributes from non-matching certification agencies are excluded from results. */
  standardizationBody?: string[];

  /** Customer identities that enable customer-specific product visibility and "product available by customer" features. */
  customers?: Customer[];
}

export interface ApplicationFilters {
  /** ABB Detail Group codes (e.g. "4121", "4131"). Restricts results to products whose "ABB Detail Group" attribute matches one of the provided values. */
  buId?: string[];

  /** Producing Unit codes (e.g. "FIDRI", "SEMOT"). Restricts results to products whose "Producing Unit" attribute matches one of the provided values. */
  puId?: string[];

  /** Sales Organization codes (e.g. "SUDESTO", "SUNOCRL"). Restricts results to products associated with the specified Local Sales Organizations. */
  suId?: string[];

  /** One or more CID identifiers from the ABB Offering Tree. Restricts results to product instances classified below the specified CIDs. */
  restrictedCids?: string[];

  /** Sales ERP filter. When `true`, returns only products where SalesErp = "Y". When `false`, excludes products without SalesErp or with SalesErp = "N". When `null`, no filter is applied. */
  salesErp?: boolean;

  /** Data Owner identifiers. Includes supplier-specific products (marked with "Supplier Specific Detail" = "Yes") that are normally hidden from regular customers. */
  dataOwners?: string[];

  /** Product identifier filter. Restricts results to only products matching the provided identifiers. */
  productIdentifiers?: string[];

  /** Attribute-based inclusion criteria. Only products matching all specified attribute code\/value pairs will be returned. */
  inclusionCriteria?: Criteria[];

  /** Attribute-based exclusion criteria. Products matching any specified attribute code\/value pair will be excluded from results. */
  exclusionCriteria?: Criteria[];

  /** When `true`, results are sorted in the order of the provided Pis.Products.Models.ApplicationFilters.ProductIdentifiers list. */
  sortByProductIdentifiers?: boolean;

  /**  */
  categoryInclusionCriteria?: CategoryCriteria;

  /**  */
  categoryExclusionCriteria?: CategoryCriteria;
}

export interface ApplicationUseSettings {
  /** Disable application use check.
When set to true the default logic for Application Use and Application Use Type user fields is ignored. */
  disable?: boolean;

  /** List of exception cids */
  exceptionCids?: string[];
}

export interface Attribute {
  /** Attribute code */
  attributeCode: string;

  /** Attribute name */
  attributeName: string;
}

export interface AttributeGroup {
  /** Attribute group code */
  code: string;

  /** Attribute group description */
  description: string;

  /** Attribute group visibility */
  visible: boolean;

  /** Attribute group spare part supplier code */
  sparePartSupplier?: string;

  /** Dictionary of product attributes
Key is attribute code */
  attributes: {[key: string]: ProductAttribute};

  /** Linked relationship */
  relationshipCode?: string;
}

export interface AttributeGroupSearchResult {
  /** Attribute group items */
  items?: AttributeGroup[];

  /** Applied AGM detail page list code. */
  listCode?: string;
}

export interface AttributeValue {
  /** Attribute value. Formatted for presentation.
Supports translations. In case of enumeration value label translation is returned. In case of multidimensional */
  text: string;

  /** Enumeration value code
Populated only for attributes of type Enumeration */
  enumerationValueCode?: string;

  /** Parsed attribute value with valid product identifiers marked inside double curly braces "{{ProductId}}".
Example: Log \/ Set incl. 1 pc {{3BSE007949R1}} DSAI 146 */
  interactiveText?: string;

  /**  */
  link?: Link;
}

export interface AuthorizeCatalogUser {
  /**  */
  catalogUser: CatalogUser;

  /** Secret */
  secret: string;
}

export interface AutocompleteCategoryItem {
  /** Full classification path from root to this category. */
  breadcrumbs?: BreadcrumbItem[];

  /** Category images. */
  images?: Image[];

  /** Keywords associated with this category that matched the search term. */
  keywords?: string[];

  /**  */
  match?: BreadcrumbItem;
}

export interface AutocompleteItem {
  /** Customer-specific alias identifiers for this product. */
  aliases?: string[];

  /** Replacement products available for this item (e.g. successor or substitute products). */
  replacements?: ProductReplacement[];

  /** Additional metadata entries attached to this product (e.g. configurator links, ordering info). */
  additionalInfo?: ProductAdditionalInfo[];

  /** When `true`, the product is inactive and navigation to detail\/preview should be disabled in the UI. */
  inactive?: boolean;

  /** Hides detail images */
  hideImages?: boolean;

  /** Hides detail "Where Used" information for Kit components */
  hideWhereUsed?: boolean;

  /** Product images. */
  images?: Image[];

  /** Indicates whether the product is published and visible for the current application. */
  published?: boolean;

  /** All available PRM relationship identifiers for this product (e.g. accessories, spare parts, replacements). */
  allRelationships?: PrmRelationshipIdentifier[];

  /** Indicates whether variants of the product are available. */
  variantsAvailable?: boolean;

  /** List of variant attributes associated with the product item */
  variantAttributes?: Attribute[];

  /** Customer specific data. Contains information such as Customer system id, customer sales unit, customer id, and restriction status for each customer. */
  customerSpecificData?: CustomerSpecificData[];

  /** Extended Object Data (EOM) associated with the product. Contains additional metadata and structured information for the product.
To retrieve EOM data, Pis.Products.Models.Actions.SearchQuery.IncludeExtendedObjectData must be set to `true`. */
  extendedObjectData?: EomObject[];

  /** Product domain */
  productIdDomain?: string;

  /** Identifies whether product is spare part. */
  sparePart: boolean;

  /** Exact Match is true when search text matches any of product identifiers. */
  exactMatch: boolean;

  /**  */
  classifications?: ProductItemClassifications;

  /** Product identifier. */
  productId: string;

  /** Dictionary of product attributes keyed by attribute code. */
  attributes: {[key: string]: ProductAttribute};
}

export interface AutocompleteQuery {
  /**  */
  appSettings: AppSettings;

  /**  */
  pager?: PagerSettings;

  /**  */
  search: SearchSettings;

  /** When `true`, includes classification category suggestions in the autocomplete response. */
  categorySearch?: boolean;

  /** When `true`, includes keyword-based category suggestions. Requires Pis.Products.Models.Actions.AutocompleteQuery.CategorySearch to be `true`. */
  categoryKeywordSearch?: boolean;

  /** When `true`, automatically navigates to the category if all results fall within a single classification node. */
  autoCategoryNavigation?: boolean;

  /** When `true`, product images are included in the autocomplete suggestion items. */
  fetchProductImages?: boolean;

  /** When `true`, category images are included in the autocomplete category suggestions. */
  fetchCategoryImages?: boolean;
}

export interface AutocompleteSearchResult {
  /** Total product count at the root classification level (ignoring CID scope). */
  rootTotalCount: number;

  /** Total product count at the root level without any active filters. Only provided when both `TotalCount` and `RootTotalCount` are zero. */
  noFiltersTotalCount: number;

  /** Legacy product name matches. Deprecated — use `Items` instead. */
  matches?: string[];

  /** Category suggestions sorted alphabetically. Populated when !:AutocompleteQuery.CategorySearch is enabled. */
  categories?: AutocompleteCategoryItem[];

  /**  */
  autoCategoryNavigationCategory?: BreadcrumbItem;

  /** Collection of product items matching the search criteria for the current page. */
  items?: AutocompleteItem[];

  /** Total number of products matching the search criteria across all pages. */
  totalCount: number;
}

export interface BreadcrumbItem {
  /** CID of the breadcrumb */
  cid: string;

  /** Name of the breadcrumb */
  name: string;

  /** Determines if the current breadcrumb should be navigable. */
  inactive: boolean;
}

export interface BreadcrumbsSearchResult {
  /** Ordered list of breadcrumb nodes from root to the current classification level. */
  items?: BreadcrumbItem[];
}

export interface Catalog {
  /** Catalog unique identifier */
  id: string;

  /** Catalog code */
  code: string;

  /**  */
  type: CatalogTypeEnum;

  /**  */
  owner: Owner;

  /** Catalog description */
  description: string;

  /** Catalog modified date */
  dateModified: Date;

  /** Catalog created date */
  dateCreated: Date;
}

export interface CatalogAction {
  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogActionResult {
  /**  */
  catalog?: Catalog;

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface CatalogAddAction {
  /** Catalog code */
  code: string;

  /**  */
  type: CatalogTypeEnum;

  /** Catalog description */
  description: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogAppSettings {
  /**  */
  client?: ClientInfo;

  /**  */
  catalogType?: CatalogTypeEnum;

  /** Application code identifying the front-end application. Products are filtered by their Publishers attribute to match this code. Required. */
  appCode: string;

  /** ISO language code for translations of labels, attribute names, and values. Defaults to "en" (English). */
  langCode?: string;

  /**  */
  appSpecific?: CatalogAppSpecificSettings;

  /**  */
  aliases?: AliasSettings;
}

export interface CatalogAppSpecificSettings {
  /** Enables configured item aliases. When enabled all configured items will have alias view, search and editing features. */
  configuredItemAliasesEnabled?: boolean;
}

export interface CatalogAutocompleteItem {
  /** Catalog code or owner in case of searching by owner */
  code: string;

  /** Catalog description.
Empty in case of searching by owner. */
  description?: string;
}

export interface CatalogAutocompleteQuery {
  /**  */
  search: CatalogSearchSettings;

  /**  */
  appSettings: CatalogAppSettings;

  /**  */
  pager?: PagerSettings;
}

export interface CatalogAutocompleteSearchResult {
  /** Total hit count of matches */
  totalCount: number;

  /** List of alphabetically sorted matches */
  matches?: string[];

  /** List of alphabetically sorted catalog items.
This list contains more information about found catalogs or owners. */
  items?: CatalogAutocompleteItem[];
}

export interface CatalogCopyAction {
  /** Source catalog unique identifier */
  sourceCatalogId: string;

  /** Target catalog unique identifier */
  targetCatalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogCopyToNewAction {
  /** Source catalog unique identifier */
  sourceCatalogId: string;

  /** New catalog code */
  code: string;

  /**  */
  type: CatalogTypeEnum;

  /** New catalog description */
  description: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogDetail {
  /** Editable */
  editable: boolean;

  /** Quantities */
  quantities?: QuantityItem[];

  /** Catalog unique identifier */
  id: string;

  /** Catalog code */
  code: string;

  /**  */
  type: CatalogTypeEnum;

  /**  */
  owner: Owner;

  /** Catalog description */
  description: string;

  /** Catalog modified date */
  dateModified: Date;

  /** Catalog created date */
  dateCreated: Date;
}

export interface CatalogExportAction {
  /**  */
  priceSettings?: CatalogExportPriceSettings;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogExportActionResult {
  /**  */
  type?: CatalogExportResultTypeEnum;

  /** Download guid */
  guid?: string;

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface CatalogExportPriceSettings {
  /** Price export enabled */
  enabled: boolean;

  /** List of emails */
  emails: string[];
}

export interface CatalogGetQuery {
  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogImportAction {
  /** File content in Base64 */
  fileContentBase64: string;

  /** File name */
  fileName: string;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogItem {
  /** Default catalog */
  default: boolean;

  /** Editable */
  editable: boolean;

  /** Total count of products in catalog */
  productsTotalCount: number;

  /** Catalog unique identifier */
  id: string;

  /** Catalog code */
  code: string;

  /**  */
  type: CatalogTypeEnum;

  /**  */
  owner: Owner;

  /** Catalog description */
  description: string;

  /** Catalog modified date */
  dateModified: Date;

  /** Catalog created date */
  dateCreated: Date;
}

export interface CatalogOption {
  /**  */
  type?: CatalogTypeEnum;
}

export interface CatalogOptionsQuery {
  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogOptionsResult {
  /** List of catalog options */
  items?: CatalogOption[];

  /** Default user email for catalog export with prices */
  email?: string;

  /** Indicates whenever prices are available for current customer System Id */
  pricesAvailable?: boolean;

  /** Indicates whenever aliases are editable for current customer System Id */
  aliasesEditable?: boolean;
}

export interface CatalogProductAddAction {
  /** Products to add */
  products: CatalogProductAddItem[];

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogProductAddItem {
  /** Product id */
  productId: string;

  /**  */
  productType: CatalogProductTypeEnum;

  /** Description */
  description?: string;

  /** Customer classification */
  customerClassification?: string;

  /** Base product id */
  baseProductId?: string;

  /** Quantity */
  quantity: number;

  /** Unit of measure */
  unitOfMeasure: string;

  /** Store additional information used by front end application */
  store?: string;

  /** Custom fields to store additional information in key value pair format used by front end application */
  customFields?: CustomFieldItem[];

  /** Alternate Product id */
  alternateProductId?: string;
}

export interface CatalogProductAutocompleteQuery {
  /**  */
  search: CatalogProductSearchSettings;

  /**  */
  catalogSearch?: CatalogSearchSettings;

  /**  */
  appSettings: CatalogAppSettings;

  /**  */
  pager?: PagerSettings;

  /** Enables fetching images for products */
  fetchProductImages?: boolean;
}

export interface CatalogProductCountQuery {
  /**  */
  search: CatalogProductSearchSettings;

  /**  */
  catalogSearch?: CatalogSearchSettings;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogProductDeleteAction {
  /** Products to delete */
  products: CatalogProductDeleteItem[];

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogProductDeleteItem {
  /** Product id */
  productId: string;
}

export interface CatalogProductFilterSearchSettings {
  /** List of filter attribute codes */
  attributeCodes: string[];

  /** CID of the tree node */
  cid?: string;

  /** Catalog id */
  catalogId?: string;

  /** Search text */
  searchText?: string;

  /**  */
  searchType: CatalogProductSearchTypeEnum;

  /**  */
  treeType?: TreeTypeEnum;

  /**  */
  aliases?: AliasesEnum;

  /** List of Pis.Catalogs.Models.Actions.CatalogProductSearchSettings.FilterSettings for which data will be filtered */
  filterSettings?: FilterSettings[];
}

export interface CatalogProductFiltersQuery {
  /**  */
  search: CatalogProductFilterSearchSettings;

  /**  */
  catalogSearch?: CatalogSearchSettings;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogProductItem {
  /** List of aliases */
  aliases?: AliasItem[];

  /** Specifies whenever product is inactive and navigation for details and preview should be disabled. */
  inactive: boolean;

  /** Catalogs */
  catalogs?: CatalogDetail[];

  /**  */
  productType: CatalogProductTypeEnum;

  /** Product images */
  images?: Image[];

  /**  */
  baseProduct?: ProductItem;

  /** Customer classification */
  customerClassification?: string;

  /** Product modified date

In Alias mode, property contains latest DateModified from all product aliases. */
  dateModified?: Date;

  /** Product created date

In Alias mode, property contains latest DateCreated from all product aliases. */
  dateCreated?: Date;

  /** Custom fields to store additional information in key value pair format used by front end application */
  customFields?: CustomFieldItem[];

  /** Specifies whenever product was imported */
  imported?: boolean;

  /** Import order (whenever product was imported) */
  importOrder?: number;

  /** Alternate Product id */
  alternateProductId?: string;

  /** Product domain */
  productIdDomain?: string;

  /** Identifies whether product is spare part. */
  sparePart: boolean;

  /** Exact Match is true when search text matches any of product identifiers. */
  exactMatch: boolean;

  /**  */
  classifications?: ProductItemClassifications;

  /** Product identifier. */
  productId: string;

  /** Dictionary of product attributes keyed by attribute code. */
  attributes: {[key: string]: ProductAttribute};
}

export interface CatalogProductSearchQuery {
  /** Search data types to retrieve */
  dataTypes: CatalogProductSearchDataTypeEnum[];

  /** List of attribute codes for which retrieve values (this list replaces default attributes).
Attribute code can use "*" pattern to match more than one attributes. For example: "LeadTime_*" */
  attributeCodes?: string[];

  /**  */
  search?: CatalogProductSearchSettings;

  /**  */
  catalogSearch?: CatalogSearchSettings;

  /**  */
  sort?: CatalogProductSortSettings;

  /**  */
  appSettings: CatalogAppSettings;

  /**  */
  pager?: PagerSettings;

  /** Max product images to fetch.
Default is 1. */
  maxProductImages?: number;
}

export interface CatalogProductSearchResult {
  /**  */
  productClassifications?: ClassificationsSearchResult;

  /**  */
  partClassifications?: ClassificationsSearchResult;

  /**  */
  products?: CatalogProductsSearchResult;

  /**  */
  filters?: FilterSearchResult;

  /**  */
  breadcrumbs?: BreadcrumbsSearchResult;
}

export interface CatalogProductSearchSettings {
  /** CID of the tree node */
  cid?: string;

  /** Catalog id */
  catalogId?: string;

  /** Search text */
  searchText?: string;

  /**  */
  searchType: CatalogProductSearchTypeEnum;

  /**  */
  treeType?: TreeTypeEnum;

  /**  */
  aliases?: AliasesEnum;

  /** List of Pis.Catalogs.Models.Actions.CatalogProductSearchSettings.FilterSettings for which data will be filtered */
  filterSettings?: FilterSettings[];
}

export interface CatalogProductSortSettings {
  /**  */
  field: CatalogProductSortFieldEnum;

  /**  */
  direction: SortDirectionEnum;
}

export interface CatalogProductUpdateAction {
  /** Products to update */
  products: CatalogProductUpdateItem[];

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogProductUpdateItem {
  /** Product id */
  productId: string;

  /** Description */
  description?: string;

  /** Customer classification */
  customerClassification?: string;

  /** Base product id */
  baseProductId?: string;

  /** Quantity */
  quantity: number;

  /** Unit of measure */
  unitOfMeasure: string;

  /** Store additional information used by front end application */
  store?: string;

  /** Custom fields to store additional information in key value pair format used by front end application */
  customFields?: CustomFieldItem[];

  /** Alternate Product id */
  alternateProductId?: string;
}

export interface CatalogProductsSearchResult {
  /** Collection of product items matching the search criteria for the current page. */
  items?: CatalogProductItem[];

  /** Total number of products matching the search criteria across all pages. */
  totalCount: number;
}

export interface CatalogSearchQuery {
  /**  */
  search?: CatalogSearchSettings;

  /**  */
  sort?: CatalogSortSettings;

  /**  */
  appSettings: CatalogAppSettings;

  /**  */
  pager?: PagerSettings;
}

export interface CatalogSearchResult {
  /** List of catalog items */
  items?: CatalogItem[];

  /** Total catalogs count */
  totalCount: number;
}

export interface CatalogSearchSettings {
  /** Created within last days */
  createdWithinLastDays?: number;

  /** Search text */
  searchText?: string;

  /**  */
  searchType: CatalogSearchTypeEnum;
}

export interface CatalogSortSettings {
  /**  */
  field: CatalogSortFieldEnum;

  /**  */
  direction: SortDirectionEnum;
}

export interface CatalogUpdateAction {
  /** Catalog description */
  description?: string;

  /** Default catalog */
  default?: boolean;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface CatalogUser {
  /** Identifier of the company system used to determine catalog ownership for company-level catalogs. */
  systemId?: string;

  /** Sales unit of the company used together with Pis.Catalogs.Models.Dto.Users.CatalogUser.SystemId and Pis.Catalogs.Models.Dto.Users.CatalogUser.CustomerId to identify the company owner. */
  salesUnit?: string;

  /** Customer identifier of the company used together with Pis.Catalogs.Models.Dto.Users.CatalogUser.SystemId and Pis.Catalogs.Models.Dto.Users.CatalogUser.SalesUnit to identify the company owner. */
  customerId?: string;

  /** Unique personal identifier of the user. Used to determine catalog ownership for personal-level catalogs. */
  userId: string;

  /** List of host codes whose catalogs should be displayed in the current view.
Host code catalogs are read-only unless the current user is the owner of the catalog. */
  displayHostCodes?: string[];

  /** Host code of the user. When provided, newly created catalogs will be shared host code catalogs. */
  hostCode?: string;

  /** Currency code used for pricing calculations during pricing export. */
  pricingCurrency?: string;

  /** Shipment method or destination used for pricing calculations during pricing export. */
  pricingShipment?: string;

  /** Country code used for pricing calculations during pricing export. */
  pricingCountry?: string;

  /** System identifier used for pricing context. May differ from Pis.Catalogs.Models.Dto.Users.CatalogUser.SystemId when pricing is resolved from a different system. */
  pricingSystemId?: string;

  /** Customer identifier used for pricing context. May differ from Pis.Catalogs.Models.Dto.Users.CatalogUser.CustomerId when pricing is resolved for a different customer. */
  pricingCustomerId?: string;

  /** Sales unit used for pricing context. May differ from Pis.Catalogs.Models.Dto.Users.CatalogUser.SalesUnit when pricing is resolved from a different sales unit. */
  pricingSalesUnit?: string;
}

export interface CategoryCriteria {
  /** Classification node identifiers (CIDs) that define which category branches to include or exclude. */
  cids: string[];
}

export interface ClassificationAdditionalInfo {
  /**  */
  type?: ClassificationAdditionalInfoTypeEnum;

  /** Value of the additional information. The actual type depends on Pis.Products.Models.Dto.Classifications.ClassificationAdditionalInfo.Type (e.g., boolean for AllowPriceList, string for ParentNodeCid). */
  value?: any | null;
}

export interface ClassificationItem {
  /** Children classifications */
  children?: ClassificationItem[];

  /** Products count */
  hitCount: number;

  /** Gets or sets the number of configurator jump points within this classification item.
This property is null by default and is only populated when configurator data is explicitly requested.
This property is populated from the data source when either:
<list type="bullet"><item>The Pis.Products.Models.Actions.ClassificationSearchSettings.Configurators property is set to true in Pis.Products.Models.Actions.ClassificationQuery for the Classifications\/Tree method.<\/item><item>The Pis.Products.Models.Actions.SearchDataTypeEnum.Configurators datatype is used in Pis.Products.Models.Actions.SearchQuery for the Products\/Search method.<\/item><\/list> */
  configuratorHitCount?: number;

  /** Has children.
If true node has child nodes. When lower levels are not requested then Pis.Products.Models.Dto.Classifications.ClassificationItem.Children array will be empty and HasChildren will be true. */
  hasChildren: boolean;

  /** Classification images. */
  images?: Image[];

  /** Gets the classification unique identifier for the classification node. */
  cid: string;

  /** Gets the name of the classification node. */
  name: string;

  /** Gets the level of the classification node within the hierarchy. */
  nodeLevel?: string;

  /** Gets the usage type of the classification node. */
  nodeUse?: string;

  /** Classification additional info.
List of Pis.Products.Models.Dto.Classifications.ClassificationAdditionalInfo */
  additionalInfo?: ClassificationAdditionalInfo[];
}

export interface ClassificationNode {
  /** Gets the classification unique identifier for the classification node. */
  cid: string;

  /** Gets the name of the classification node. */
  name: string;

  /** Gets the level of the classification node within the hierarchy. */
  nodeLevel?: string;

  /** Gets the usage type of the classification node. */
  nodeUse?: string;

  /** Classification additional info.
List of Pis.Products.Models.Dto.Classifications.ClassificationAdditionalInfo */
  additionalInfo?: ClassificationAdditionalInfo[];
}

export interface ClassificationNodesQuery {
  /**  */
  search: ClassificationNodesSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface ClassificationNodesSearchResult {
  /** Collection of classification nodes matching the query criteria. */
  items?: ClassificationNode[];
}

export interface ClassificationNodesSearchSettings {
  /** CID's of the tree nodes */
  cids: string[];
}

export interface ClassificationParentsQuery {
  /**  */
  search: ClassificationParentsSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface ClassificationParentsSearchSettings {
  /** CID of the tree node */
  cid: string;
}

export interface ClassificationQuery {
  /**  */
  search: ClassificationSearchSettings;

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return per classification node. Defaults to 1. */
  maxClassificationImages?: number;
}

export interface ClassificationSearchSettings {
  /** CID of the tree node
If CID will be not provided ROOT tree will be returned */
  cid?: string;

  /** Tree depth to retrieve.
Default value: 0 - returns all child's of Cid node. */
  treeDepth: number;

  /** Returns configurator hit counts in Pis.Products.Models.Dto.Classifications.ClassificationItem */
  configurators?: boolean;
}

export interface ClassificationsBrowserAppSettings {
  /**  */
  client?: ClientInfo;

  /** Country code.
The Country Market Availability and Country Market Availability Type attribute values associated with a product
instance determine the countries where a product will be seen.
Filters the results to only the product instances available for the designated Country */
  countryCode?: string;

  /** Application code identifying the front-end application. Products are filtered by their Publishers attribute to match this code. Required. */
  appCode: string;

  /** ISO language code for translations of labels, attribute names, and values. Defaults to "en" (English). */
  langCode?: string;

  /**  */
  filters?: ClassificationsBrowserFilters;

  /** Product Line Period.
Allows the user to select the product line period of the Product Line Tree that will be displayed in the Product Line Tree link. */
  productLinePeriod?: string;
}

export interface ClassificationsBrowserAutocompleteQuery {
  /**  */
  search: ClassificationsBrowserSearchSettings;

  /**  */
  appSettings: ClassificationsBrowserAppSettings;

  /**  */
  pager?: PagerSettings;
}

export interface ClassificationsBrowserAutocompleteResult {
  /** Total number of classification names matching the search text. */
  totalCount: number;

  /** Alphabetically sorted list of classification names matching the autocomplete query (paginated). */
  matches?: string[];
}

export interface ClassificationsBrowserChildrenQuery {
  /**  */
  search: ClassificationsBrowserChildrenSearchSettings;

  /**  */
  appSettings: ClassificationsBrowserAppSettings;
}

export interface ClassificationsBrowserChildrenResult {
  /** Collection of child classification nodes. */
  items?: ClassificationsBrowserNode[];
}

export interface ClassificationsBrowserChildrenSearchSettings {
  /** CID of the tree node */
  cid: string;

  /** List of selected CID's */
  selectedCids?: string[];

  /**  */
  treeType?: ClassificationsBrowserTreeTypeEnum;
}

export interface ClassificationsBrowserFilters {
  /**  */
  applicationUse?: ApplicationUseSettings;

  /** List of Life Cycle Phase.
As a default, the Classifications Browser view shows only nodes with a Life Cycle Phase of Active and Restricted. */
  lifeCyclePhases?: string[];

  /**  */
  countryMarketAvailability?: CountryMarketAvailabilitySettings;

  /**  */
  lifeCyclePhaseMode?: LifeCyclePhaseModeEnum;
}

export interface ClassificationsBrowserNode {
  /** Unique classification identifier (CID) of this node. */
  cid: string;

  /** Localized display name of the classification node. */
  name: string;

  /** English name of the classification node (used as fallback or for reference). */
  enName?: string;

  /** Child nodes of this classification in the tree hierarchy. */
  children?: ClassificationsBrowserNode[];

  /** Indicates whether the search text exactly matches this node's name. */
  match: boolean;

  /** Indicates whether this node is a leaf (has no children). */
  leaf: boolean;

  /**  */
  tree: ClassificationsBrowserTreeTypeEnum;

  /** Indicates whether this node can be selected by the user in the browser. */
  selectable: boolean;

  /**  */
  productGroup: ProductGroup;

  /**  */
  reference?: ClassificationsBrowserNodeReference;
}

export interface ClassificationsBrowserNodeReference {
  /** Tree CID from Original CID */
  classificationCode?: string;

  /** Original CID */
  cid?: string;

  /** CID from parent node */
  refCid?: string;

  /** Path to CID */
  refPath?: string;
}

export interface ClassificationsBrowserPathNode {
  /** CID of the classification */
  cid: string;

  /**  */
  tree?: ClassificationsBrowserTreeTypeEnum;
}

export interface ClassificationsBrowserPathQuery {
  /**  */
  search: ClassificationsBrowserPathSearchSettings;

  /**  */
  appSettings: ClassificationsBrowserAppSettings;
}

export interface ClassificationsBrowserPathSearchSettings {
  /**  */
  node: ClassificationsBrowserPathNode;
}

export interface ClassificationsBrowserSearchQuery {
  /**  */
  search: ClassificationsBrowserSearchSettings;

  /**  */
  appSettings: ClassificationsBrowserAppSettings;
}

export interface ClassificationsBrowserSearchResult {
  /** Collection of classification nodes matching the search criteria. */
  items?: ClassificationsBrowserNode[];

  /** Collection of currently selected classification nodes for reference. */
  selectedItems?: ClassificationsBrowserNode[];

  /** Indicates whether the search results exceeded the configured limit and were truncated. */
  limitExceeded?: boolean;

  /** Maximum number of results that can be returned. Results are truncated when this limit is exceeded. */
  limit?: number;
}

export interface ClassificationsBrowserSearchSettings {
  /** Text to be search */
  searchText?: string;

  /** List of selected CID's */
  selectedCids?: string[];

  /** List of favorite CID's */
  favoriteCids?: string[];

  /**  */
  treeView?: ClassificationsBrowserTreeViewEnum;

  /** When not set or set to false, the favorites are not expandable.
When set to true, the favorites are expandable and the user can add items from favorite nodes children. */
  favoriteItemsExpandable?: boolean;
}

export interface ClassificationsBrowserValidateNode {
  /** CID of the classification */
  cid: string;

  /**  */
  tree?: ClassificationsBrowserTreeTypeEnum;
}

export interface ClassificationsBrowserValidateQuery {
  /**  */
  search: ClassificationsBrowserValidateSearchSettings;

  /**  */
  appSettings: ClassificationsBrowserAppSettings;
}

export interface ClassificationsBrowserValidateResult {
  /** Collection of CIDs that were found to be valid classification nodes. */
  validNodes?: ClassificationsBrowserNode[];

  /** Collection of CIDs that were not found or are invalid, with additional context. */
  invalidNodes?: ClassificationsBrowserValidateNode[];
}

export interface ClassificationsBrowserValidateSearchSettings {
  /** List of nodes */
  nodes: ClassificationsBrowserValidateNode[];
}

export interface ClassificationsSearchResult {
  /** Additional metadata for the requested classification node (e.g., description, image). */
  additionalInfo?: ClassificationAdditionalInfo[];

  /** Collection of classification tree items (child nodes of the requested CID or root). */
  items?: ClassificationItem[];
}

export interface ClientInfo {
  /** End client IP address. */
  ipAddress?: string;

  /** End-client user agent string (browser identifier). */
  userAgent?: string;
}

export interface CompareClassificationItem {
  /** Full breadcrumb path from root to this classification node. */
  breadcrumb?: BreadcrumbItem[];

  /** Children classifications */
  children?: ClassificationItem[];

  /** Products count */
  hitCount: number;

  /** Gets or sets the number of configurator jump points within this classification item.
This property is null by default and is only populated when configurator data is explicitly requested.
This property is populated from the data source when either:
<list type="bullet"><item>The Pis.Products.Models.Actions.ClassificationSearchSettings.Configurators property is set to true in Pis.Products.Models.Actions.ClassificationQuery for the Classifications\/Tree method.<\/item><item>The Pis.Products.Models.Actions.SearchDataTypeEnum.Configurators datatype is used in Pis.Products.Models.Actions.SearchQuery for the Products\/Search method.<\/item><\/list> */
  configuratorHitCount?: number;

  /** Has children.
If true node has child nodes. When lower levels are not requested then Pis.Products.Models.Dto.Classifications.ClassificationItem.Children array will be empty and HasChildren will be true. */
  hasChildren: boolean;

  /** Classification images. */
  images?: Image[];

  /** Gets the classification unique identifier for the classification node. */
  cid: string;

  /** Gets the name of the classification node. */
  name: string;

  /** Gets the level of the classification node within the hierarchy. */
  nodeLevel?: string;

  /** Gets the usage type of the classification node. */
  nodeUse?: string;

  /** Classification additional info.
List of Pis.Products.Models.Dto.Classifications.ClassificationAdditionalInfo */
  additionalInfo?: ClassificationAdditionalInfo[];
}

export interface CompareProductDetail {
  /**  */
  item?: ProductItem;

  /** Attribute groups with values for this product, aligned with the comparison matrix. */
  attributeGroups?: AttributeGroup[];
}

export interface CompareQuery {
  /**  */
  search: CompareSearchSettings;

  /** Attribute codes to include in the comparison. Overrides the default AGM list. Supports wildcard patterns (e.g. "LeadTime_*"). */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return per product. Defaults to 1. */
  maxProductImages?: number;
}

export interface CompareResult {
  /** Classification nodes shared by the compared products, including breadcrumb paths. */
  classifications?: CompareClassificationItem[];

  /** Compared product details with their aligned attribute groups. */
  items?: CompareProductDetail[];
}

export interface CompareSearchSettings {
  /** Product identifiers to compare (two or more required). */
  productIds: string[];

  /**  */
  mergeMethod: AttributeMergeMethodEnum;

  /** When `true`, only attribute rows where at least one product differs are included in the result. */
  differencesOnly?: boolean;

  /** Optional CID scope. Limits the attribute groups to those defined under the specified classification nodes. */
  cids?: string[];

  /** When `true`, only attributes used on the product detail page are compared. */
  strictMode?: boolean;

  /** When `true`, document attribute values are normalized to "Y" (available) or empty for comparison display. */
  specialDocumentHandling?: boolean;
}

export interface Configuration {
  /** Configuration product number */
  productNumber: string;

  /** List of Pis.Catalogs.Models.Dto.Products.ConfigurationGroup groups */
  groups?: ConfigurationGroup[];

  /** Configuration modified date */
  dateModified: Date;

  /** Configuration created date */
  dateCreated: Date;

  /** Configuration xml.
This XML does not contains entire xml; only ItemDetails node. */
  xml: string;

  /** Configuration unique identifier */
  id: string;

  /** Configuration product id */
  productId: string;
}

export interface ConfigurationActionResult {
  /** Configurations created \/ updated */
  configurations?: Configuration[];

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface ConfigurationAddAction {
  /** Quantity unique identifier */
  quantityId: string;

  /** Configuration xml */
  xml: string;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface ConfigurationDeleteAction {
  /** Configuration id */
  id: string;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface ConfigurationElement {
  /** Product */
  product: string;

  /** Description */
  description: string;

  /** Quantity */
  quantity: number;

  /** Unit of measure */
  unitOfMeasure: string;
}

export interface ConfigurationGetQuery {
  /** Configuration id */
  id: string;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface ConfigurationGroup {
  /** Name */
  name: string;

  /** List of Pis.Catalogs.Models.Dto.Products.ConfigurationElement elements */
  elements: ConfigurationElement[];
}

export interface ConfigurationId {
  /** Configuration unique identifier */
  id: string;

  /** Configuration product id */
  productId: string;
}

export interface ConfigurationItem {
  /** Editable */
  editable: boolean;

  /** Configuration product number */
  productNumber: string;

  /** List of Pis.Catalogs.Models.Dto.Products.ConfigurationGroup groups */
  groups?: ConfigurationGroup[];

  /** Configuration modified date */
  dateModified: Date;

  /** Configuration created date */
  dateCreated: Date;

  /** Configuration xml.
This XML does not contains entire xml; only ItemDetails node. */
  xml: string;

  /** Configuration unique identifier */
  id: string;

  /** Configuration product id */
  productId: string;
}

export interface ConfigurationUpdateAction {
  /** Configuration id */
  id: string;

  /** Configuration xml */
  xml: string;

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface ConfiguratorItem {
  /** Product id */
  productId: string;

  /** Description */
  description: string;

  /** Code */
  code: string;
}

export interface ConfiguratorItemSearchResult {
  /** Configurator entries with their classification hit counts. */
  items?: ConfiguratorItem[];
}

export interface CountQuery {
  /**  */
  appSettings: AppSettings;

  /**  */
  search: SearchSettings;
}

export interface CountSearchResult {
  /** Total number of products matching the search criteria. */
  totalCount: number;
}

export interface CountryMarketAvailabilitySettings {
  /** Disable country market availability check.
When set to true the default logic for Country Market Availability and Country Market Availability Type user fields
is ignored. */
  disable?: boolean;
}

export interface Criteria {
  /** The attribute code to match against, or "CID" to filter by classification node identifier. */
  code: string;

  /** Values to match. For attribute codes, provide attribute values (wildcards supported: "Value*", "*Value", "*Value*"). For "CID", provide classification node identifiers. */
  values: string[];
}

export interface CustomFieldItem {
  /** Custom fields key */
  key: string;

  /** Custom field value */
  value: string;
}

export interface Customer {
  /** System identifier the customer belongs to. */
  systemId: string;

  /** Sales unit associated with the customer. */
  salesUnit: string;

  /** Unique customer identifier within the system and sales unit. */
  customerId: string;
}

export interface CustomerSpecificData {
  /** Customer system id */
  systemId?: string;

  /** Customer sales unit */
  salesUnit?: string;

  /** Customer id */
  customerId?: string;

  /** Restricted. Indicates whether the product is restricted for the specific customer. */
  restricted?: boolean;
}

export interface DetailQuery {
  /**  */
  search: ProductDetailSettings;

  /** Data sections to include in the response (e.g. ProductDetails, AttributeGroups, ProductRelationships). At least one value is required. */
  dataTypes: DetailDataTypeEnum[];

  /** Attribute codes to return. Overrides the default AGM list. Supports wildcard patterns (e.g. "LeadTime_*"). */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return for the product. Defaults to 6. */
  maxProductImages?: number;
}

export interface EomAttribute {
  /** Attribute dto */
  attributeCode: string;

  /** List of values */
  values?: EomAttributeValue[];
}

export interface EomAttributeValue {
  /** Value */
  value: string;

  /** Label */
  label: string;

  /** Translations
Dictionary < LanguageCode, Value > */
  translations?: object;
}

export interface EomObject {
  /** Type (e.g. RelatedLink, SparePartPublisherOverride) */
  type: string;

  /** Code (combination of ObjectType Code and id of object) */
  code: string;

  /** Code */
  name: string;

  /** Description */
  description: string;

  /** List of attributes */
  attributes?: EomAttribute[];
}

export interface EomSearchResult {
  /** List of Pis.Data.ProcessedData.Eom.EomObject items */
  items?: EomObject[];
}

export interface ErrorResult {
  /** Human-readable description of the error. */
  message?: string;

  /** Additional technical details about the error (e.g., stack trace or inner exception information). */
  errorDetails?: string;

  /** Unique trace identifier for correlating the error with server-side logs. */
  traceId?: string;

  /**  */
  type?: ErrorResultType;
}

export interface ExportActionResult {
  /** Download guid */
  guid?: string;

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface FavoriteView {
  /** Unique identifier of the favorite view. */
  id?: string;

  /** User-defined code or name for the favorite view. */
  code?: string;

  /**  */
  data?: FavoriteViewData;
}

export interface FavoriteViewData {
  /**  */
  treeType: TreeTypeEnum;

  /**  */
  pager: PagerSettings;

  /**  */
  search: SearchSettings;

  /**  */
  sort: SortSettings;
}

export interface FavoriteViewDeleteQuery {
  /**  */
  favoriteView: FavoriteViewDeleteSettings;

  /**  */
  appSettings: AppSettings;
}

export interface FavoriteViewDeleteSettings {
  /** Favorite view identifier */
  id: string;
}

export interface FavoriteViewSaveQuery {
  /**  */
  favoriteView: FavoriteViewSaveSettings;

  /**  */
  appSettings: AppSettings;
}

export interface FavoriteViewSaveSettings {
  /** Favorite view id */
  id?: string;

  /** Favorite view code */
  code: string;

  /**  */
  data: FavoriteViewData;
}

export interface FavoriteViewsQuery {
  /**  */
  search: FavoriteViewsSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface FavoriteViewsSearchResult {
  /** Collection of favorite views matching the requested identifiers. */
  items?: FavoriteView[];
}

export interface FavoriteViewsSearchSettings {
  /** List of favorite view identifiers to retrieve. */
  ids: string[];
}

export interface FeedbackQuery {
  /**  */
  feedback: FeedbackSettings;

  /**  */
  appSettings: AppSettings;
}

export interface FeedbackSettings {
  /** Identifier of the product the feedback relates to. */
  productId: string;

  /** Optional name of the user submitting the feedback. */
  userName?: string;

  /** Optional email address of the user submitting the feedback. */
  userEmail?: string;

  /** Free-text feedback comment provided by the user. */
  text: string;

  /**  */
  rating: FeedbackRatingEnum;
}

export interface FilterAttributeValue {
  /** Human-readable display name of the filter value. */
  name: string;

  /** Internal code of the filter value, used for programmatic matching. */
  code?: string;
}

export interface FilterItem {
  /** Internal attribute code identifying this filter dimension. */
  attributeCode: string;

  /** Localized display name of the attribute. */
  attributeName: string;

  /** Attribute display name with HTML formatting (e.g. subscript\/superscript for units). */
  attributeNameHtml: string;

  /** Total number of products that have a value for this attribute in the current result set. */
  hitCount: number;

  /** Whether this filter should be promoted (displayed expanded). Deprecated — use Pis.Products.Models.Dto.Filters.FilterItem.Promoted instead. */
  isPromoted: boolean;

  /** When `true`, this filter should be displayed expanded; other filters should be collapsed. */
  promoted: boolean;

  /** When `true`, this filter is only visible to internal users. */
  internal: boolean;
}

export interface FilterSearchResult {
  /** Filter facet items, each representing an attribute with its selectable values. */
  items?: FilterItem[];
}

export interface FilterSearchSettings {
  /** Attribute codes for which to compute and return selectable filter values. */
  attributeCodes: string[];

  /** Classification node identifier (CID) to scope the search to a specific tree branch. */
  cid?: string;

  /**  */
  partType: PartTypeEnum;

  /** Master product id. Used to narrow down search results to products related to the specified master product. */
  masterProductId?: string;

  /** List of Pis.Products.Models.Actions.SearchSettings.FilterSettings for which data will be filtered */
  filterSettings?: FilterSettings[];

  /** Free-text search term used to match products by name, description, or attribute values. */
  searchText?: string;

  /**  */
  searchType: SearchTypeEnum;
}

export interface FilterSettings {
  /** Attribute code identifying the filter dimension (e.g. "Voltage", "ProductGroup"). */
  attributeCode?: string;

  /** Selected filter values (plain strings). Deprecated — use Pis.Products.Models.Actions.FilterSettings.Values instead. */
  attributeValues?: string[];

  /** Selected filter values with optional codes. Preferred over Pis.Products.Models.Actions.FilterSettings.AttributeValues. */
  values?: FilterAttributeValue[];
}

export interface FilterValue {
  /** Number of products matching this specific filter value in the current result set. */
  hitCount: number;

  /** Human-readable display name of the filter value. */
  name: string;

  /** Internal code of the filter value, used for programmatic matching. */
  code?: string;
}

export interface FilterValueItem {
  /** Selectable values for this filter attribute, each with a product hit count. */
  values?: FilterValue[];

  /** Internal attribute code identifying this filter dimension. */
  attributeCode: string;

  /** Localized display name of the attribute. */
  attributeName: string;

  /** Attribute display name with HTML formatting (e.g. subscript\/superscript for units). */
  attributeNameHtml: string;

  /** Total number of products that have a value for this attribute in the current result set. */
  hitCount: number;

  /** Whether this filter should be promoted (displayed expanded). Deprecated — use Pis.Products.Models.Dto.Filters.FilterItem.Promoted instead. */
  isPromoted: boolean;

  /** When `true`, this filter should be displayed expanded; other filters should be collapsed. */
  promoted: boolean;

  /** When `true`, this filter is only visible to internal users. */
  internal: boolean;
}

export interface FilterValueSearchResult {
  /** Filter facets with their selectable values and product hit counts. */
  items?: FilterValueItem[];
}

export interface FiltersQuery {
  /**  */
  search: FilterSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface Image {
  /** Url of image */
  url: string;

  /** Thumbnail url of image */
  thumbnailUrl: string;

  /** Master url of image */
  masterUrl: string;

  /** Specifies whenever served image is "no-image". */
  noImage?: boolean;
}

export interface ImageByClassificationCidsQuery {
  /**  */
  search: ImageClassificationSearchSettings;

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return per classification node. Defaults to 1. */
  maxClassificationImages?: number;
}

export interface ImageByImageIdsQuery {
  /**  */
  search: ImageSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface ImageByProductIdsQuery {
  /**  */
  search: ImageProductSearchSettings;

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return per product. Defaults to 6. */
  maxProductImages?: number;
}

export interface ImageClassificationSearchSettings {
  /** List of classification CID's */
  cids: string[];
}

export interface ImageItem {
  /** Unique identifier of the image. */
  imageId?: string;

  /** Identifier of the product this image is associated with (null for classification images). */
  productId?: string;

  /** Global identifier of the product. */
  globalId?: string;

  /** Classification node identifier this image is associated with (null for product images). */
  cid?: string;

  /** Url of image */
  url: string;

  /** Thumbnail url of image */
  thumbnailUrl: string;

  /** Master url of image */
  masterUrl: string;

  /** Specifies whenever served image is "no-image". */
  noImage?: boolean;
}

export interface ImageProductSearchSettings {
  /** List of product id or global id */
  products?: string[];

  /** List of product ids */
  productIds?: string[];
}

export interface ImageSearchResult {
  /** List of Pis.Products.Models.Dto.Images.ImageItem items */
  items?: ImageItem[];
}

export interface ImageSearchSettings {
  /** List of image ids */
  imageIds: string[];
}

export interface InteractiveGuide {
  /** Description */
  description: string;

  /** Document number */
  documentNumber?: string;

  /** File type (extension) */
  fileType?: string;

  /**  */
  securityLevel: SecurityLevelEnum;

  /** Url to file */
  url?: string;

  /**  */
  type?: InteractiveGuideTypeEnum;

  /** Type description */
  typeDescription?: string;
}

export interface InteractiveGuidesSearchResult {
  /** List of Pis.Products.Models.Dto.InteractiveGuides.InteractiveGuide items */
  items?: InteractiveGuide[];
}

export interface JobAction {
  /** Job unique identifier */
  jobId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface JobItem {
  /** Job unique identifier */
  id: string;

  /**  */
  owner: Owner;

  /**  */
  catalog?: Catalog;

  /**  */
  type: JobTypeEnum;

  /**  */
  status: JobStatusEnum;

  /** Catalog modified date */
  dateModified: Date;

  /** Catalog created date */
  dateCreated: Date;
}

export interface JobSearchQuery {
  /**  */
  sort?: JobSortSettings;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface JobSearchResult {
  /** List of job items */
  items?: JobItem[];
}

export interface JobSortSettings {
  /**  */
  field: JobSortFieldEnum;

  /**  */
  direction: SortDirectionEnum;
}

export interface Link {
  /** Text of link */
  text: string;

  /** Product id
This value exists only for the Link equals Detail */
  productId?: string;

  /** Search text
This value exists only for the Link equals Search */
  searchText?: string;

  /** Cid
This value exists only for the Link equals Classification */
  cid?: string;

  /** Document id
This value exists only for the Link equals Document */
  documentId?: string;

  /**  */
  type: LinkTypeEnum;
}

export interface ListQuery {
  /**  */
  search: ListSearchSettings;

  /** Attribute codes to return for each product. Replaces the default attribute set. Supports wildcard patterns (e.g. "LeadTime_*"). */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return per product. Defaults to 1. */
  maxProductImages?: number;

  /** When `true`, each product in the response includes its classification node assignments. */
  includeProductClassifications?: boolean;
}

export interface ListSearchSettings {
  /** Product identifiers to retrieve. */
  productIds: string[];
}

export interface LoginQuery {
  /** Application (client) ID from the Azure AD app registration. */
  clientId: string;

  /** Client secret generated for the Azure AD app registration. */
  clientSecret: string;
}

export interface LoginResult {
  /** Bearer access token to be used in the Authorization header for subsequent API requests. */
  accessToken?: string;
}

export interface MapSettings {
  /** Attribute code to sort by. MultiDimensional and Translatable attribute types are not supported. */
  attributeCode: string;

  /**  */
  direction?: SortDirectionEnum;

  /** Custom value order for sorting. Products are ranked by the position of their attribute value in this list. When `null`, alphabetical sorting using Pis.Products.Models.MapSettings.Direction is applied instead. */
  values?: string[];
}

export interface MasterProduct {
  /** Product id */
  productId: string;

  /** Number of spare parts */
  hitCount: number;

  /** Description of master product */
  description: string;
}

export interface MasterProductSearchResult {
  /** Master product items. May be `null` when Pis.Products.Models.Dto.MasterProducts.MasterProductSearchResult.TotalCount exceeds the maximum allowed and results cannot be displayed. */
  items?: MasterProduct[];

  /** Total number of master products matching the criteria. When this value exceeds the maximum threshold and `Items` is `null`, the result set is too large to display. */
  totalCount: number;
}

export interface NotFoundResult {
  /**  */
  statusCode?: number;
}

export interface Owner {
  /** Owner unique identifier */
  id?: string;

  /** User id */
  userId?: string;

  /** System id */
  systemId?: string;

  /** Customer id */
  customerId?: string;

  /** Sales unit */
  salesUnit?: string;

  /**  */
  type?: OwnerTypeEnum;
}

export interface PagerSettings {
  /** Page number to retrieve (1-based). Defaults to 1. */
  page: number;

  /** Number of items per page. Defaults to 10. */
  pageSize: number;
}

export interface PartType {
  /**  */
  type?: PartTypeEnum;

  /** Part type name */
  name?: string;
}

export interface PartTypesSearchResult {
  /** Part type entries with their display names and product counts. */
  items?: PartType[];
}

export interface PdfQuery {
  /**  */
  search: ProductSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface PreviewQuery {
  /**  */
  search: ProductPreviewSettings;

  /** Attribute codes to return. Overrides the default AGM attribute set. Supports wildcard patterns (e.g. "LeadTime_*"). */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /** Maximum number of images to return for the product. Defaults to 6. */
  maxProductImages?: number;
}

export interface PriceListQuery {
  /** Optional set of attribute codes to include in the response. Supports wildcard patterns (e.g., "LeadTime_*") to match multiple attributes. */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /**  */
  pager?: PagerSettings;

  /**  */
  search?: SearchSettings;

  /**  */
  sort?: SortSettings;
}

export interface PriceListSearchResult {
  /**  */
  classifications?: ClassificationNodesSearchResult;

  /**  */
  products?: ProductPriceListSearchResult;
}

export interface PrintResult {
  /** Unique identifier used to retrieve the generated PDF file via the download endpoint. */
  guid?: string;
}

export interface PrmEntitiesQuery {
  /**  */
  search: PrmEntitiesSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface PrmEntitiesSearchResult {
  /** Collection of products with their associated PRM relationship entities. */
  items?: ProductPrmRelationshipEntities[];
}

export interface PrmEntitiesSearchSettings {
  /** List of product identifiers to search relationships for. When provided, the Pis.Products.Models.Actions.PrmEntitiesSearchSettings.Suppliers property is ignored. */
  productIds?: string[];

  /** List of supplier identifiers to search relationships for. Ignored when Pis.Products.Models.Actions.PrmEntitiesSearchSettings.ProductIds is provided. */
  suppliers?: string[];

  /** Optional filter to limit results to specific PRM list codes. */
  prmListCodes?: string[];

  /** Optional filter to limit results to specific PRM type codes. */
  prmTypeCodes?: string[];
}

export interface PrmFilterSettings {
  /** Attribute codes for which to return available filter values. */
  attributeCodes: string[];

  /** Classification node identifier. Deprecated — has no effect on search results. */
  cid?: string;

  /** Optional PRM relationship code to filter by a specific relationship definition. */
  relationshipCode?: string;

  /**  */
  relationshipType: PrmRelationshipTypeEnum;

  /** Free-text search applied to related products within the relationship. */
  searchText?: string;

  /** Optional filter criteria to narrow relationship results. */
  filterSettings?: FilterSettings[];

  /** Product id */
  productId: string;
}

export interface PrmFiltersQuery {
  /**  */
  search: PrmFilterSettings;

  /**  */
  appSettings: AppSettings;
}

export interface PrmProductInfoEntity {
  /** Ghost product cids */
  ghostProductCids?: string[];

  /** Global id */
  globalId?: string;

  /** Identifier */
  id?: string;

  /**  */
  idType?: PrmIdTypeEnum;

  /** Order */
  order?: number;

  /** Sp roll down */
  spRollDown?: boolean;

  /** User field values */
  userFieldValues?: PrmUserFieldValueEntity[];
}

export interface PrmQuery {
  /**  */
  pager?: PagerSettings;

  /**  */
  search: PrmSearchSettings;

  /**  */
  appSettings: AppSettings;
}

export interface PrmRelationship {
  /** Unique code identifying this PRM relationship definition. */
  code: string;

  /** Localized display name of the relationship. */
  description: string;

  /**  */
  type: PrmRelationshipTypeEnum;

  /**  */
  orgType?: PrmRelationshipOrgTypeEnum;

  /** Organization code associated with this relationship, if applicable. */
  orgCode?: string;

  /** Image URLs for this relationship. Only populated for Pis.Products.Models.Dto.Prm.PrmRelationshipTypeEnum.Accessories relationships. */
  images?: string[];

  /**  */
  table?: Table;

  /** Custom user-defined fields associated with this relationship. */
  userFields?: UserField[];

  /** Available filter facets for narrowing related products within this relationship. */
  filters?: FilterItem[];
}

export interface PrmRelationshipEntity {
  /** PRM relationship code */
  code: string;

  /** PRM relationship description */
  description: string;

  /** PRM relationship org type */
  orgType?: string;

  /** PRM relationship org code */
  orgCode?: string;

  /** PRM images */
  images?: string[];

  /** PRM relationship type code */
  typeCode?: string;

  /** PRM relationship type description */
  typeDescription?: string;

  /** Master products */
  masterProducts?: PrmProductInfoEntity[];

  /** Related products */
  relatedProducts?: PrmProductInfoEntity[];

  /** Relationship user field values */
  relationshipUserFieldValues?: PrmUserFieldValueEntity[];

  /** Type user field values */
  typeUserFieldValues?: PrmUserFieldValueEntity[];
}

export interface PrmRelationshipIdentifier {
  /** PRM relationship code */
  relationshipCode: string;

  /** PRM relationship type */
  relationshipType: string;

  /** Spare part secondary supplier from the relationship user field code 'SparePartSupplier'. */
  sparePartSupplier?: string;
}

export interface PrmSearchResult {
  /** Collection of PRM relationships for the queried product. */
  items?: PrmRelationship[];
}

export interface PrmSearchSettings {
  /** Classification node identifier. Deprecated — has no effect on search results. */
  cid?: string;

  /** Optional PRM relationship code to filter by a specific relationship definition. */
  relationshipCode?: string;

  /**  */
  relationshipType: PrmRelationshipTypeEnum;

  /** Free-text search applied to related products within the relationship. */
  searchText?: string;

  /** Optional filter criteria to narrow relationship results. */
  filterSettings?: FilterSettings[];

  /** Product id */
  productId: string;
}

export interface PrmUserFieldValueEntity {
  /** Code */
  code?: string;

  /** Description */
  description?: string;

  /** Order */
  order?: number;

  /** Values */
  values?: string[];
}

export interface ProductAdditionalInfo {
  /**  */
  type?: ProductAdditionalInfoTypeEnum;

  /** Text */
  text?: string;
}

export interface ProductAttribute {
  /**  */
  type: AttributeTypeEnum;

  /** Attribute code */
  attributeCode: string;

  /** Attribute translated name */
  attributeName?: string;

  /** Attribute values
Only for Pis.Products.Models.Dto.Products.AttributeTypeEnum.TextPis.Products.Models.Dto.Products.AttributeTypeEnum.Enum type */
  values?: AttributeValue[];

  /**  */
  table?: Table;

  /** Determines if ProductAttribute is internal */
  isInternal: boolean;

  /** Determines if ProductAttribute is internal */
  internal: boolean;

  /** Tool tip */
  tooltip?: string;

  /** Highlight
Indicates if the Product Attribute should be highlighted. */
  highlight: boolean;
}

export interface ProductClassificationsSearchResult {
  /** Dictionary of product breadcrumbs
Key is Pis.Products.Models.Dto.TreeTypeEnum */
  items?: object;
}

export interface ProductDetail {
  /**  */
  productDetails?: ProductDetailSearchResult;

  /**  */
  attributeGroups?: AttributeGroupSearchResult;

  /**  */
  productClassifications?: ProductClassificationsSearchResult;

  /**  */
  productRelationships?: PrmSearchResult;

  /**  */
  interactiveGuides?: InteractiveGuidesSearchResult;

  /**  */
  relatedLinks?: RelatedLinksSearchResult;

  /**  */
  relatedProducts?: RelatedProductsSearchResult;

  /**  */
  productVariantsSelector?: ProductVariantsSelectorSearchResult;

  /**  */
  productVariantsTable?: ProductVariantsTableSearchResult;

  /**  */
  productVariantsDropdown?: ProductVariantsDropdownSearchResult;

  /**  */
  extendedObjectData?: EomSearchResult;
}

export interface ProductDetailSearchResult {
  /**  */
  item?: ProductItem;
}

export interface ProductDetailSettings {
  /** Optional classification node identifier to scope attribute groups and related data to a specific tree branch. */
  cid?: string;

  /** Product id */
  productId: string;
}

export interface ProductGroup {
  /**  */
  status: ProductGroupValidationStatusEnum;

  /** Product group code */
  code?: string;

  /** Product group name */
  name?: string;
}

export interface ProductItem {
  /** Customer-specific alias identifiers for this product. */
  aliases?: string[];

  /** Replacement products available for this item (e.g. successor or substitute products). */
  replacements?: ProductReplacement[];

  /** Additional metadata entries attached to this product (e.g. configurator links, ordering info). */
  additionalInfo?: ProductAdditionalInfo[];

  /** When `true`, the product is inactive and navigation to detail\/preview should be disabled in the UI. */
  inactive?: boolean;

  /** Hides detail images */
  hideImages?: boolean;

  /** Hides detail "Where Used" information for Kit components */
  hideWhereUsed?: boolean;

  /** Product images. */
  images?: Image[];

  /** Indicates whether the product is published and visible for the current application. */
  published?: boolean;

  /** All available PRM relationship identifiers for this product (e.g. accessories, spare parts, replacements). */
  allRelationships?: PrmRelationshipIdentifier[];

  /** Indicates whether variants of the product are available. */
  variantsAvailable?: boolean;

  /** List of variant attributes associated with the product item */
  variantAttributes?: Attribute[];

  /** Customer specific data. Contains information such as Customer system id, customer sales unit, customer id, and restriction status for each customer. */
  customerSpecificData?: CustomerSpecificData[];

  /** Extended Object Data (EOM) associated with the product. Contains additional metadata and structured information for the product.
To retrieve EOM data, Pis.Products.Models.Actions.SearchQuery.IncludeExtendedObjectData must be set to `true`. */
  extendedObjectData?: EomObject[];

  /** Product domain */
  productIdDomain?: string;

  /** Identifies whether product is spare part. */
  sparePart: boolean;

  /** Exact Match is true when search text matches any of product identifiers. */
  exactMatch: boolean;

  /**  */
  classifications?: ProductItemClassifications;

  /** Product identifier. */
  productId: string;

  /** Dictionary of product attributes keyed by attribute code. */
  attributes: {[key: string]: ProductAttribute};
}

export interface ProductItemClassifications {
  /** Product Class cids (PC) */
  classCids?: string[];

  /** Product Type cids (T) */
  typeCids?: string[];

  /** Product leaf cids */
  leafCids?: string[];

  /** Product Level 0 (ROOT) cids */
  level0Cids?: string[];

  /** Breadcrumbs. All item classifications with full path.
To retrieve Breadcrumbs data, Pis.Products.Models.Actions.SearchQuery.IncludeProductClassifications or Pis.Products.Models.Actions.ListQuery.IncludeProductClassifications must be set to `true`. */
  breadcrumbs?: object;
}

export interface ProductListItem {
  /** Product images. */
  images?: Image[];

  /** Product domain */
  productIdDomain?: string;

  /** Identifies whether product is spare part. */
  sparePart: boolean;

  /** Exact Match is true when search text matches any of product identifiers. */
  exactMatch: boolean;

  /**  */
  classifications?: ProductItemClassifications;

  /** Product identifier. */
  productId: string;

  /** Dictionary of product attributes keyed by attribute code. */
  attributes: {[key: string]: ProductAttribute};
}

export interface ProductListSearchResult {
  /** Collection of product items matching the search criteria for the current page. */
  items?: ProductListItem[];

  /** Total number of products matching the search criteria across all pages. */
  totalCount: number;
}

export interface ProductPreview {
  /**  */
  item?: ProductItem;
}

export interface ProductPreviewSettings {
  /** Optional classification node identifier used to scope the product context. */
  cid?: string;

  /** Optional filter criteria applied to narrow down the product data. */
  filterSettings?: FilterSettings[];

  /** Product id */
  productId: string;
}

export interface ProductPriceListItem {
  /** Product identifier. */
  productId: string;

  /** Dictionary of product attributes keyed by attribute code. */
  attributes: {[key: string]: ProductAttribute};
}

export interface ProductPriceListSearchResult {
  /** Collection of product items matching the search criteria for the current page. */
  items?: ProductPriceListItem[];

  /** Total number of products matching the search criteria across all pages. */
  totalCount: number;
}

export interface ProductPrmRelationshipEntities {
  /** Product id */
  productId?: string;

  /** Supplier */
  supplier?: string;

  /** List of Pis.Products.Models.Dto.Prm.PrmRelationshipEntity relationships */
  relationships?: PrmRelationshipEntity[];
}

export interface ProductReplacement {
  /** Label */
  label: string;

  /**  */
  link?: Link;
}

export interface ProductSearchResult {
  /** Collection of product items matching the search criteria for the current page. */
  items?: ProductItem[];

  /** Total number of products matching the search criteria across all pages. */
  totalCount: number;
}

export interface ProductSearchSettings {
  /** Product id */
  productId: string;
}

export interface ProductSitemapItem {
  /** Date and time when the product was last modified in PIM. Used to populate the lastmod element in sitemap XML. */
  lastModified?: Date;

  /** Product identifier. */
  productId: string;

  /** Dictionary of product attributes keyed by attribute code. */
  attributes: {[key: string]: ProductAttribute};
}

export interface ProductVariantAttribute {
  /**  */
  displayMode?: VariantAttributeDisplayModeEnum;

  /** Attribute values */
  values?: ProductVariantValue[];

  /** Attribute code */
  attributeCode: string;

  /** Attribute name */
  attributeName: string;
}

export interface ProductVariantGroup {
  /** Attribute code */
  attributeCode: string;

  /** Attribute name */
  attributeName: string;

  /** User-friendly display text with translation support.
For enumerations: translated label.
For multidimensional attributes: concatenated header, value, and unit of measure. */
  attributeValueText: string;

  /** Variant attributes that are dependent on this attribute */
  variantAttributes: ProductVariantGroupAttribute[];

  /** Products */
  products: ProductItem[];
}

export interface ProductVariantGroupAttribute {
  /** Attribute code */
  attributeCode: string;

  /** Attribute name */
  attributeName: string;
}

export interface ProductVariantValue {
  /** User-friendly display text with translation support.
For enumerations: translated label.
For multidimensional attributes: concatenated header, value, and unit of measure. */
  attributeValueText?: string;

  /** Selection state indicating if this variant value matches the current product.
Used for highlighting active selections in variant filters. */
  selected?: boolean;

  /** Indicates whether the product variant value matches the specified criteria. */
  match?: boolean;

  /**  */
  product?: ProductItem;
}

export interface ProductVariantsDropdownSearchResult {
  /** List of Pis.Products.Models.Dto.ProductVariants.ProductVariantGroup items */
  items?: ProductVariantGroup[];
}

export interface ProductVariantsSelectorSearchResult {
  /** List of Pis.Products.Models.Dto.ProductVariants.ProductVariantAttribute items */
  items?: ProductVariantAttribute[];
}

export interface ProductVariantsTableSearchResult {
  /** List of Pis.Products.Models.Dto.ProductVariants.ProductVariantGroup items */
  items?: ProductVariantGroup[];
}

export interface Quantity {
  /** Quantity id */
  id: string;

  /** Quantity value */
  value: number;

  /** Quantity unit of measure */
  unitOfMeasure: string;

  /** Store */
  store?: string;

  /** Configuration ids */
  configurationIds?: ConfigurationId[];

  /** Quantity modified date */
  dateModified: Date;

  /** Quantity created date */
  dateCreated: Date;
}

export interface QuantityActionResult {
  /** Quantities created \/ updated */
  quantities?: Quantity[];

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface QuantityAddAction {
  /** List of quantities */
  quantities: QuantityAddItem[];

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface QuantityAddItem {
  /** Product id */
  productId: string;

  /** Unit of measure */
  unitOfMeasure: string;

  /** Quantity value */
  value: number;

  /** Store */
  store?: string;
}

export interface QuantityCopyAction {
  /** Source catalog unique identifier */
  sourceCatalogId: string;

  /** Target catalog unique identifier */
  targetCatalogId: string;

  /** List of source quantity unique identifiers */
  sourceQuantityIds: string[];

  /**  */
  appSettings: CatalogAppSettings;
}

export interface QuantityCopyToNewAction {
  /** Source catalog unique identifier */
  sourceCatalogId: string;

  /** New catalog code */
  code: string;

  /**  */
  type: CatalogTypeEnum;

  /** New catalog description */
  description: string;

  /** List of source quantity unique identifiers */
  sourceQuantityIds: string[];

  /**  */
  appSettings: CatalogAppSettings;
}

export interface QuantityDeleteAction {
  /** List of quantities */
  quantities: QuantityDeleteItem[];

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface QuantityDeleteItem {
  /** Quantity unique identifier */
  id: string;
}

export interface QuantityItem {
  /** Editable */
  editable: boolean;

  /** Quantity id */
  id: string;

  /** Quantity value */
  value: number;

  /** Quantity unit of measure */
  unitOfMeasure: string;

  /** Store */
  store?: string;

  /** Configuration ids */
  configurationIds?: ConfigurationId[];

  /** Quantity modified date */
  dateModified: Date;

  /** Quantity created date */
  dateCreated: Date;
}

export interface QuantityUpdateAction {
  /** List of quantities */
  quantities: QuantityUpdateItem[];

  /** Catalog unique identifier */
  catalogId: string;

  /**  */
  appSettings: CatalogAppSettings;
}

export interface QuantityUpdateItem {
  /** Quantity unique identifier */
  id: string;

  /** Quantity value */
  value: number;

  /** Store */
  store?: string;
}

export interface RelatedLink {
  /** Related link text */
  text?: string;

  /** Related link url */
  url?: string;

  /** Related link image */
  image?: string;

  /** Is related link internal */
  internal?: boolean;
}

export interface RelatedLinksSearchResult {
  /** List of Pis.Products.Models.Dto.RelatedLinks.RelatedLink items */
  items?: RelatedLink[];
}

export interface RelatedProduct {
  /** Parent product condition. 'PartType' attribute value. */
  condition?: string;

  /** Related product id */
  productId?: string;

  /** Related product global commercial alias */
  gloComAli?: string;
}

export interface RelatedProductsSearchResult {
  /** Current product condition. First 'PartType' attribute value. */
  condition?: string;

  /** List of Pis.Products.Models.Dto.RelatedProducts.RelatedProduct items */
  items?: RelatedProduct[];
}

export interface Route {
  /**  */
  systemType: SystemTypeEnum;

  /** Route system id */
  systemId: string;

  /** Route ois */
  ois: string;
}

export interface RoutingTableActionResult {
  /** Routes created \/ updated */
  routes?: Route[];

  /** Action success */
  success: boolean;

  /** Action message */
  message?: string;

  /** Action errors */
  errors?: ActionInfo[];

  /** Action warnings */
  warnings?: ActionInfo[];
}

export interface RoutingTableGetQuery {
  /**  */
  appSettings: CatalogAppSettings;
}

export interface RoutingTablePostAction {
  /** Routes to post */
  routes: Route[];

  /**  */
  appSettings: CatalogAppSettings;
}

export interface SearchQuery {
  /** Data sections to include in the response (e.g. Products, Classifications, Filters). At least one value is required. */
  dataTypes: SearchDataTypeEnum[];

  /** Attribute codes to return for each product. Replaces the default attribute set. Supports wildcard patterns (e.g. "LeadTime_*"). */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /**  */
  pager?: PagerSettings;

  /**  */
  search?: SearchSettings;

  /**  */
  sort?: SortSettings;

  /** Maximum number of images to return per product. Defaults to 1. */
  maxProductImages?: number;

  /** Maximum number of images to return per classification node. Defaults to 1. */
  maxClassificationImages?: number;

  /** When `true`, each product in the response includes its classification node assignments. */
  includeProductClassifications?: boolean;

  /** When `true`, each product in the response includes Extended Object Data (EOM). */
  includeExtendedObjectData?: boolean;
}

export interface SearchResult {
  /**  */
  classifications?: ClassificationsSearchResult;

  /**  */
  products?: ProductSearchResult;

  /**  */
  filters?: FilterSearchResult;

  /**  */
  breadcrumbs?: BreadcrumbsSearchResult;

  /**  */
  configurators?: ConfiguratorItemSearchResult;

  /**  */
  masterProducts?: MasterProductSearchResult;

  /**  */
  interactiveGuides?: InteractiveGuidesSearchResult;

  /**  */
  partTypes?: PartTypesSearchResult;
}

export interface SearchSettings {
  /** Classification node identifier (CID) to scope the search to a specific tree branch. */
  cid?: string;

  /**  */
  partType: PartTypeEnum;

  /** Master product id. Used to narrow down search results to products related to the specified master product. */
  masterProductId?: string;

  /** List of Pis.Products.Models.Actions.SearchSettings.FilterSettings for which data will be filtered */
  filterSettings?: FilterSettings[];

  /** Free-text search term used to match products by name, description, or attribute values. */
  searchText?: string;

  /**  */
  searchType: SearchTypeEnum;
}

export interface SitemapProductSearchQuery {
  /**  */
  search?: SitemapProductSearchSettings;

  /** Optional set of attribute codes to include in the response (replaces the default attribute list).
Supports wildcard patterns (e.g., "LeadTime_*") to match multiple attributes. */
  attributeCodes?: string[];

  /**  */
  appSettings: AppSettings;

  /**  */
  pager?: PagerSettings;
}

export interface SitemapProductSearchResult {
  /** Collection of product items matching the search criteria for the current page. */
  items?: ProductSitemapItem[];

  /** Total number of products matching the search criteria across all pages. */
  totalCount: number;
}

export interface SitemapProductSearchSettings {
  /** Classification node identifier (CID) to filter products belonging to a specific category in the product tree. */
  cid?: string;

  /** Optional date filter to return only products modified in PIM on or after this date. */
  fromDate?: Date;
}

export interface SortSettings {
  /**  */
  field: SortFieldEnum;

  /**  */
  direction: SortDirectionEnum;
}

export interface Table {
  /** List of Pis.Products.Models.Dto.Table.TableColumn columns */
  columns: TableColumn[];

  /** List of Pis.Products.Models.Dto.Table.TableRow rows */
  rows: TableRow[];

  /** Rows total count */
  rowsTotalCount: number;
}

export interface TableColumn {
  /** Text */
  text: string;

  /** Data field */
  dataField: string;
}

export interface TableRow {
  /** Dictionary of Pis.Products.Models.Dto.Table.TableColumn.DataField and Pis.Products.Models.Dto.Table.TableValue */
  values: {[key:string]:TableValue[]}[];
}

export interface TableValue {
  /** Text */
  text?: string;

  /** Tool tip */
  tooltip?: string;

  /**  */
  link?: Link;
}

export interface TranslationItem {
  /** Name of the component this translation belongs to. */
  component: string;

  /** Resource key identifying this translation within the component. */
  key: string;

  /** Localized translation value for the requested language (falls back to English if unavailable). */
  value: string;
}

export interface TranslationQuery {
  /** Optional list of component names to filter translations. If null or empty, translations for all components are returned. */
  components?: string[];

  /**  */
  appSettings?: AppSettings;
}

export interface UserField {
  /** Name of the user field */
  name?: string;

  /** Values of the user field */
  values?: string[];
}

export interface VariantSettings {
  /** When `true`, similar product variants are grouped (clustered) together in the response. When `false` or `null`, each variant product is returned individually. */
  clustering?: boolean;
}

export enum AliasesEnum {
  'All' = 'All',
  'Blank' = 'Blank',
  'Populated' = 'Populated'
}

export enum AttributeMergeMethodEnum {
  'Merge' = 'Merge',
  'FirstFound' = 'FirstFound',
  'Flat' = 'Flat'
}

export enum AttributeTypeEnum {
  'Text' = 'Text',
  'Enum' = 'Enum',
  'Table' = 'Table',
  'NotApplicable' = 'NotApplicable',
  'Populated' = 'Populated'
}

export enum CatalogExportResultTypeEnum {
  'Download' = 'Download',
  'Job' = 'Job'
}

export enum CatalogProductSearchDataTypeEnum {
  'ProductClassifications' = 'ProductClassifications',
  'PartClassifications' = 'PartClassifications',
  'Products' = 'Products',
  'Filters' = 'Filters',
  'Breadcrumbs' = 'Breadcrumbs'
}

export enum CatalogProductSearchTypeEnum {
  'WithAllWords' = 'WithAllWords',
  'WithAtLeastOneWord' = 'WithAtLeastOneWord',
  'ExactPhrase' = 'ExactPhrase'
}

export enum CatalogProductSortFieldEnum {
  'LastImport' = 'LastImport',
  'Product' = 'Product',
  'Alias' = 'Alias',
  'LastModified' = 'LastModified',
  'Hierarchical' = 'Hierarchical'
}

export enum CatalogProductTypeEnum {
  'Listed' = 'Listed',
  'Unlisted' = 'Unlisted',
  'Configured' = 'Configured'
}

export enum CatalogSearchTypeEnum {
  'CatalogCodeAndDescription' = 'CatalogCodeAndDescription',
  'CreatedBy' = 'CreatedBy',
  'CatalogCode' = 'CatalogCode'
}

export enum CatalogSortFieldEnum {
  'LastModified' = 'LastModified',
  'Code' = 'Code',
  'Description' = 'Description'
}

export enum CatalogTypeEnum {
  'Company' = 'Company',
  'Personal' = 'Personal'
}

export enum ClassificationAdditionalInfoTypeEnum {
  'AllowPriceList' = 'AllowPriceList',
  'AllowPriceListTotalCount' = 'AllowPriceListTotalCount',
  'ParentNodeCid' = 'ParentNodeCid',
  'ParentNodeName' = 'ParentNodeName',
  'ProductGroup' = 'ProductGroup',
  'NavigationTypeSort' = 'NavigationTypeSort'
}

export enum ClassificationsBrowserTreeTypeEnum {
  'Offering' = 'Offering',
  'ProductLine' = 'ProductLine'
}

export enum ClassificationsBrowserTreeViewEnum {
  'Offering' = 'Offering',
  'ProductLine' = 'ProductLine',
  'Favorites' = 'Favorites'
}

export enum DetailDataTypeEnum {
  'ProductDetails' = 'ProductDetails',
  'ProductClassifications' = 'ProductClassifications',
  'AttributeGroups' = 'AttributeGroups',
  'ProductRelationships' = 'ProductRelationships',
  'InteractiveGuides' = 'InteractiveGuides',
  'RelatedLinks' = 'RelatedLinks',
  'ProductVariantsSelector' = 'ProductVariantsSelector',
  'ProductVariantsTable' = 'ProductVariantsTable',
  'ProductVariantsDropdown' = 'ProductVariantsDropdown',
  'ExtendedObjectData' = 'ExtendedObjectData'
}

export enum ErrorResultType {
  'BadRequest' = 'BadRequest',
  'NotAuthorized' = 'NotAuthorized',
  'ServerError' = 'ServerError',
  'ServiceUnavailable' = 'ServiceUnavailable',
  'TooManyRequests' = 'TooManyRequests'
}

export enum FeedbackRatingEnum {
  'Poor' = 'Poor',
  'Good' = 'Good',
  'Excellent' = 'Excellent'
}

export enum InteractiveGuideTypeEnum {
  'Product' = 'Product',
  'Classification' = 'Classification'
}

export enum JobSortFieldEnum {
  'Catalog' = 'Catalog',
  'JobType' = 'JobType',
  'JobStatus' = 'JobStatus',
  'LastModified' = 'LastModified'
}

export enum JobStatusEnum {
  'InQueue' = 'InQueue',
  'Running' = 'Running',
  'Success' = 'Success',
  'Error' = 'Error',
  'Cancelled' = 'Cancelled',
  'Cancelling' = 'Cancelling'
}

export enum JobTypeEnum {
  'ExportCatalogWithPrices' = 'ExportCatalogWithPrices'
}

export enum LifeCyclePhaseModeEnum {
  'TopToBottom' = 'TopToBottom',
  'BottomToTop' = 'BottomToTop'
}

export enum LinkTypeEnum {
  'None' = 'None',
  'Detail' = 'Detail',
  'Search' = 'Search',
  'Classification' = 'Classification',
  'Document' = 'Document',
  'TechnicalInformation' = 'TechnicalInformation'
}

export enum OwnerTypeEnum {
  'Company' = 'Company',
  'Personal' = 'Personal'
}

export enum PartTypeEnum {
  'All' = 'All',
  'Standard' = 'Standard',
  'Exchange' = 'Exchange',
  'Repair' = 'Repair',
  'NewAddition' = 'NewAddition',
  'PreventativeMaintenanceKit' = 'PreventativeMaintenanceKit'
}

export enum PrmIdTypeEnum {
  'GlobalId' = 'GlobalId',
  'ProductId' = 'ProductId',
  'Ean' = 'Ean',
  'Text' = 'Text',
  'NodeCid' = 'NodeCid'
}

export enum PrmRelationshipOrgTypeEnum {
  'Sps' = 'Sps',
  'Do' = 'Do'
}

export enum PrmRelationshipTypeEnum {
  'All' = 'All',
  'Accessories' = 'Accessories',
  'AlternativeSell' = 'AlternativeSell',
  'ConsistsOf' = 'ConsistsOf',
  'CrossSell' = 'CrossSell',
  'DeviceTypeCode' = 'DeviceTypeCode',
  'DeviceTypeList' = 'DeviceTypeList',
  'KitContents' = 'KitContents',
  'SoftwareList' = 'SoftwareList',
  'UpSell' = 'UpSell',
  'SparePartSelectionList' = 'SparePartSelectionList',
  'SparePartUsedOnList' = 'SparePartUsedOnList',
  'SuperCodeBoM' = 'SuperCodeBoM',
  'WhereUsed' = 'WhereUsed',
  'EnhancedSparePartFilters' = 'EnhancedSparePartFilters',
  'Variants' = 'Variants'
}

export enum ProductAdditionalInfoTypeEnum {
  'CustomerSpecificProduct' = 'CustomerSpecificProduct',
  'MarketLimitedProduct' = 'MarketLimitedProduct',
  'CustomerSpecificProductAndMarketLimitedProduct' = 'CustomerSpecificProductAndMarketLimitedProduct'
}

export enum ProductGroupValidationStatusEnum {
  'NonApplicable' = 'NonApplicable',
  'Valid' = 'Valid',
  'Invalid' = 'Invalid'
}

export enum SearchDataTypeEnum {
  'Classifications' = 'Classifications',
  'Products' = 'Products',
  'Filters' = 'Filters',
  'Breadcrumbs' = 'Breadcrumbs',
  'Configurators' = 'Configurators',
  'MasterProducts' = 'MasterProducts',
  'InteractiveGuides' = 'InteractiveGuides',
  'PartTypes' = 'PartTypes'
}

export enum SearchTypeEnum {
  'WithAllWords' = 'WithAllWords',
  'WithAtLeastOneWord' = 'WithAtLeastOneWord',
  'ExactPhrase' = 'ExactPhrase',
  'SparePartMasterIdentifier' = 'SparePartMasterIdentifier',
  'Hierarchical' = 'Hierarchical'
}

export enum SecurityLevelEnum {
  'Internal' = 'Internal',
  'External' = 'External'
}

export enum SortDirectionEnum {
  'Ascending' = 'Ascending',
  'Descending' = 'Descending'
}

export enum SortFieldEnum {
  'Product' = 'Product',
  'Relevance' = 'Relevance'
}

export enum SystemTypeEnum {
  'Oms' = 'Oms',
  'Sap' = 'Sap'
}

export enum TreeTypeEnum {
  'Products' = 'Products',
  'Parts' = 'Parts'
}

export enum VariantAttributeDisplayModeEnum {
  'Dropdown' = 'Dropdown',
  'Pills' = 'Pills',
  'Images' = 'Images'
}
